import { Component, Inject, EventEmitter, Output, Input } from "@angular/core";
import { DefaultValuesService } from "../../../services/defaultvalues.service";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { CountryBackendEntity } from "../../../interfaces/countrybackendentity";
import { SaveService } from "../../../services/save.service";
import { Utils } from "../../../utils/utils";
import { AzDataFactoryFormComponent } from "../azdatafactory/azdatafactoryform/azdatafactoryform.component";
import { AzDataFactoryListComponent } from "../azdatafactory/azdatafactorylist/azdatafactorylist.component";
import { CdpWikiListComponent } from "../cdpwiki/cdpwiki-list.component";
import { HttpClient } from "@angular/common/http";

@Component({
    selector: 'inspection-menu',
    templateUrl: './inspection-menu.component.html',
    styleUrls: ['../../../style/menu.component.less'],
    standalone: false
})

export class InspectionMenuComponent {

    @Output() onReload = new EventEmitter<{}>();
    @Output() outputDownload = new EventEmitter<{}>();
    @Input('currentType') currentType: CountryBackendEntity = CountryBackendEntity.Inspection

    constructor(private http: HttpClient
        , private router: Router
        , @Inject('BASE_URL') private baseUrl: string
        , private dialogForm: MatDialog
        , public saveService: SaveService
        , public defaults: DefaultValuesService
    ) {
    }

    onUpload() {
        this.router.navigate(["file/" + Utils.getFileUploadInspection()]);
    }

    openAzureDataFactoryTriggerModal(isCustomerPortal: boolean) {
        this.dialogForm.open(AzDataFactoryFormComponent, {
            panelClass: 'custom-mat-dialog',
            disableClose: true,
            data: { "isCustomerPortal": isCustomerPortal, "type": CountryBackendEntity[this.currentType], "entity": isCustomerPortal ? "Customer Portal" : "InfoHub" }
        })
    }

    openDocumentationModal() {
        this.dialogForm.open(CdpWikiListComponent, {
            panelClass: 'custom-mat-dialog',
            data: { "entity": this.currentType }
        });
    }

    showLastInspectionsRuns() {
        const end = new Date();
        const start = new Date(new Date().setDate(end.getDate() - 30));
        Utils.httpGetLastPipelineRunsAzdf(
            this.http,
            this.baseUrl,
            'InfoHub',
            CountryBackendEntity[this.currentType],
            start,
            end,
            this,
            function (tthis: any, list: AzDataFactoryRun[]) {
                tthis.dialogForm.open(AzDataFactoryListComponent, {
                    panelClass: 'custom-mat-dialog',
                    disableClose: true,
                    data: { "type": CountryBackendEntity[tthis.currentType], "list": list, "entity": "InfoHub" }
                })
            });
    }
}